import { useState, useRef, useEffect } from "react";
import { Row, Col, Card, Flex, Statistic } from "antd";
import TransactionCard from "../../components/transaction/TransactionCard";
import SummaryCard from "../../components/transaction/SummaryCard";
import useFetch from "../../hooks/useFetch";
import dayjs from "dayjs";

const get_daily_income_url = "/merchant/getDailyIncome"

function TransactionPage() {
  const transactionCardRef = useRef();
  const [fetchWrapper] = useFetch();

  const [transactions, setTransactions] = useState([]);
  const [selectedTransaction, setSelectedTransaction] = useState({});
  const [plates, setPlates] = useState([]);
  const [selectedPlateIndex, setSelectedPlateIndex] = useState(0);
  const [expandedRowKeys, setExpandedRowKeys] = useState([]);
  const [dailyIncome, setDailyIncome] = useState("N/A");

  function getDailyIncome() {
    fetchWrapper({
      endpoint_url: get_daily_income_url,
      set_content_type_header: false,
      method: "GET",
      onSuccess: (fetch_output) => {
        if (!("error" in fetch_output)) {
          setDailyIncome(fetch_output.data)
        } else {
          setDailyIncome("N/A")
        }
      },
      onFetchError: () => {
        setDailyIncome("N/A")
      }
    })
  }

  useEffect(()=>{
    getDailyIncome()
  },[])

  return (
    <Row gutter={[10, 10]} style={{ height: "100%" }}>
      <Col span={24} style={{ height: "10%" }}>
        <Card 
          style={{height: "100%"}}
          styles={{
            body: {
              paddingTop: 10,
              paddingBottom: 10,
              display: 'flex',
              alignItems: 'center',
              height: "100%"
            }
          }}
        >
          <Flex>
            <Statistic
              title={"Today Income as of " + dayjs(dailyIncome.fetch_income).format('YYYY-MM-DD HH:mm:ss')}
              value={dailyIncome.daily_income ?? 0.00}
              precision={2}
              prefix={"RM "}
            />
          </Flex>
        </Card>
      </Col>
      <Col span={16} style={{ height: "calc(90% - 10px)" }}>
        <TransactionCard
          transactions={transactions}
          setTransactions={setTransactions}
          transactionCardRef={transactionCardRef}
          setSelectedTransaction={setSelectedTransaction}
          setPlates={setPlates}
          setSelectedPlateIndex={setSelectedPlateIndex}
          setExpandedRowKeys={setExpandedRowKeys}
        />
      </Col>
      <Col span={8}>
        <SummaryCard
          transactionCardRef={transactionCardRef}
          selectedTransaction={selectedTransaction}
          setSelectedTransaction={setSelectedTransaction}
          plates={plates}
          setPlates={setPlates}
          selectedPlateIndex={selectedPlateIndex}
          setSelectedPlateIndex={setSelectedPlateIndex}
          expandedRowKeys={expandedRowKeys}
          setExpandedRowKeys={setExpandedRowKeys}
        />
      </Col>
    </Row>
  );
}

export default TransactionPage;
